<template>
  <Dialog :commonDialog="bDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage {{ typeText }} </v-flex>
        <v-flex class="text-right">
          <v-btn small class="mx-4" v-on:click="createProductBrand">
            <span class="font-size-16 font-weight-600">Add {{ typeText }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="ticketCollecttionForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateProductBrand"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr v-for="(type, index) in brandList" :key="index">
                      <td>
                        <v-text-field
                          v-model.trim="type.text"
                          dense
                          filled
                          :label="typeText"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :rules="[validateRules.required(type.text, typeText)]"
                          color="cyan"
                        ></v-text-field>
                      </td>
                      <td width="50" v-if="brandList.length > 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on:click="deleteProductBrand(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateProductBrand"
      >
        Save
      </v-btn>
      <v-btn
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";
import { ProductBrandEventBus } from "@/core/lib/product.brand.lib";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    typeText: {
      type: String,
      default: null,
    },
    typeCat: {
      type: String,
      default: null,
    },
    bDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    brand: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    /* existCategory: {
      type: String,
      default: null,
    }, */
  },
  watch: {
    brand: {
      deep: true,
      immediate: true,
      handler(param) {
        this.brandList = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      brandList: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    updateProductBrand() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs.ticketCollecttionForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }
      if (_this.brandList?.length == 0) {
        ErrorEventBus.$emit("update:error", "Please add at least one row.");
        return false;
      }
      _this.pageLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url: "setting/type-wise-categories?type=" + this.typeCat,
          data: { product_brand: _this.brandList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          if (this.typeCat == "engine_type") {
            _this.$emit("get-engine-types", true);
          }
          if (this.typeCat == "insurance_company") {
            _this.$emit("get-insurance-company", true);
          }
          if (this.typeCat == "finance_company") {
            _this.$emit("get-finance-company", true);
          }

          ProductBrandEventBus.$emit("refress-brand", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createProductBrand() {
      this.brandList.push({
        text: null,
      });
    },
    deleteProductBrand(index) {
      if (this.brandList.length > 1) {
        this.brandList.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
